// extracted by mini-css-extract-plugin
export default {"logoHolder":"MainLogo_logoHolder__1zToo","isSmall":"MainLogo_isSmall__yLh1x","isCenter":"MainLogo_isCenter__fbUSu","logoImage":"MainLogo_logoImage__g+RrT"};